import React from "react";

const Button = ({
  title,
  onClick = () => {},
  className = "",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      className={`cursor-pointer outline-none uppercase tracking-widest inline-flex items-center justify-center rounded-full border-2 border-softBlack bg-softBlack min-w-[203px] px-10 py-3 text-sm font-medium text-white transition-colors duration-300 delay-75 ease-out hover:bg-transparent hover:text-softBlack hover:shadow-none active:translate-y-0 ${className}`}
      disabled={disabled}
    >
      {title}
    </button>
  );
};

export default Button;
